import React from 'react';
import './UniversityPage.css';

const UniversityPage5 = () => {
    return (
        <>
            <div className="containerr">
                <header className="header">
                    <h1>University of Rome La Sapienza</h1>
                    <h2>Dentistry and Dental Prosthetics Program</h2>
                </header>

                <section className="overview">
                    <h2>Overview</h2>
                    <p>The University of Rome La Sapienza, one of Italy's most prestigious and historic institutions, has expanded its offerings to include a fully English-taught Dentistry and Dental Prosthetics program. Starting in 2022, Sapienza joined the ranks of Italian universities providing international students with the opportunity to study dentistry in English. Alongside Siena University, which also offers a similar program, Sapienza has become a top choice for aspiring dentists seeking a high-quality education in Italy.</p>
                    <p>Located in the heart of Rome, Sapienza University is the largest university in Europe and offers unparalleled opportunities for students. With its rich history, cutting-edge facilities, and globally recognized degree, the Dentistry program at Sapienza is an excellent choice for students aiming to build a successful career in dentistry.</p>
                    <a href="https://www.uniroma1.it/en/pagina/dentistry">Learn More</a>
                </section>

                <section className="ranking">
                    <h2>International Ranking of La Sapienza</h2>
                    <p>La Sapienza consistently ranks among the top universities globally. According to the QS World University Rankings, it is one of the highest-ranked institutions in Italy. In the field of Dentistry, La Sapienza holds a strong position, often ranking within the top 200 worldwide and among the top 5 in Italy.</p>
                </section>

                <section className="seats-available">
                    <h2>Seats Available and IMAT Cut-offs</h2>
                    <p>The Dentistry program at Sapienza has a limited number of seats, divided between EU and non-EU students. The seat allocation and cut-off scores for the past years are as follows:</p>
                    <div className="table-container">
                        <table className="styled-table">
                            <thead>
                                <tr>
                                    <th>Year</th>
                                    <th>EU Seats</th>
                                    <th>EU Final Score</th>
                                    <th>Non-EU Seats</th>
                                    <th>Non-EU Final Score</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>2023</td>
                                    <td>19</td>
                                    <td>38.7</td>
                                    <td>6</td>
                                    <td>59.1</td>
                                </tr>
                                <tr>
                                    <td>2024</td>
                                    <td>19</td>
                                    <td>62.8 (first) / 61.8 (last)</td>
                                    <td>6</td>
                                    <td>73.1</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>

                <section className="why-choose">
                    <h2>Why Study Dentistry at Sapienza?</h2>
                    <p>Studying dentistry in Italy, and particularly at Sapienza University, offers numerous advantages:</p>
                    <ul>
                        <li><strong>Prestigious Education:</strong> Italian universities are known for their high-quality teaching and rigorous academic standards. Sapienza, in particular, is one of the top-ranked universities in Italy and Europe.</li>
                        <li><strong>Global Recognition:</strong> Graduates from Sapienza's Dentistry program are licensed to work not only in Italy but also across Europe and globally, as the program exceeds international standards.</li>
                        <li><strong>Affordable Tuition:</strong> Compared to other countries, tuition fees in Italy are relatively low, making it an attractive option for international students.</li>
                        <li><strong>Cultural Experience:</strong> Rome is a city rich in history, culture, and cuisine, offering students a unique and enriching living experience.</li>
                        <li><strong>Advanced Healthcare System:</strong> Italy's healthcare system is highly efficient and advanced, providing students with excellent clinical training opportunities.</li>
                    </ul>
                </section>

                <section className="course-structure">
                    <h2>Course Structure and Curriculum</h2>
                    <p>The Dentistry and Dental Prosthetics program at Sapienza is a 6-year degree, divided into pre-clinical and clinical phases. Below is an overview of the curriculum:</p>

                    <h3>1st Year</h3>
                    <ul>
                        <li>Medical Physics</li>
                        <li>Chemistry and Introduction to Biochemistry</li>
                        <li>Biology and Genetics</li>
                        <li>Human Anatomy</li>
                        <li>Basic Medical Scientific Methods</li>
                        <li>Histology and Embryology</li>
                        <li>Biochemistry</li>
                    </ul>

                    <h3>2nd Year</h3>
                    <ul>
                        <li>Principles of Dentistry</li>
                        <li>Occupational Medicine and Healthcare Management</li>
                        <li>Physiology</li>
                        <li>General Pathology</li>
                        <li>Microbiology and Hygiene</li>
                    </ul>

                    <h3>3rd Year</h3>
                    <ul>
                        <li>Dental Materials and Prosthetic Technologies</li>
                        <li>Medical Sciences</li>
                        <li>Diagnostic Imaging and Radiotherapy</li>
                        <li>Pathological Anatomy</li>
                        <li>Pharmacology</li>
                        <li>Oral Pathology and Dermatology</li>
                    </ul>

                    <h3>4th Year</h3>
                    <ul>
                        <li>Neurology and Psychiatry</li>
                        <li>Dental Prosthodontics</li>
                        <li>Forensic Medicine</li>
                        <li>Orthodontics</li>
                        <li>Restorative Dentistry</li>
                        <li>Periodontology</li>
                        <li>Surgical Sciences</li>
                        <li>Gnathology</li>
                        <li>Oral Surgery</li>
                    </ul>

                    <h3>5th Year</h3>
                    <ul>
                        <li>Orthodontics</li>
                        <li>Restorative Dentistry</li>
                        <li>Oral Implantology</li>
                        <li>Prosthetic and Periodontal Rehabilitation</li>
                        <li>Maxillo-Facial Pathology and Therapy</li>
                        <li>Pediatric Dentistry</li>
                    </ul>

                    <h3>6th Year</h3>
                    <ul>
                        <li>Integrated Oral and Dental Therapy</li>
                        <li>TPV Odontostomatological Disciplines I & II</li>
                        <li>Final Exam</li>
                    </ul>
                </section>

                <section className="facilities">
                    <h2>Facilities at Sapienza Dental School</h2>
                    <p>Sapienza University boasts state-of-the-art facilities, including well-equipped labs and classrooms. With a small number of students admitted each year, students benefit from personalized attention and access to resources like individual microscopes. The university's libraries are well-maintained, though they can get crowded during exam periods.</p>
                </section>

                <section className="exams">
                    <h2>Exams and Grading System</h2>
                    <p>Exams at Sapienza can be written, oral, or practical, depending on the subject. The grading system follows a 30-point scale:</p>
                    <ul>
                        <li><strong>18/30:</strong> Minimum passing mark</li>
                        <li><strong>30/30 cum laude:</strong> Highest grade</li>
                    </ul>
                    <p>At Sapienza University, most exams are oral, though some may include written parts as well. It really depends on the professor and the subject. Often, exams are split into two stages: first, you need to pass the written part, and then you move on to the oral exam. The oral part usually goes into more detail, testing your deeper understanding of the material.</p>
                    <p>Once you pass an exam, you earn the credits for that subject. But here's the interesting part—if you feel like your score doesn't reflect how well you prepared, you have the option to reject it. If you do, you can retake the exam in the next session. This gives you a chance to aim for a better grade and ensures your result truly matches your effort and knowledge. This system is designed to be flexible and fair, helping students perform at their best while preparing them for the challenges of a career in dentistry. Some subjects may have mid-term exams and passing these can exempt students from the final oral exam.</p>
                </section>

                <section className="clinical-experience">
                    <h2>Clinical Experience and Internships</h2>
                    <p>Practical training begins in the 2nd year with activities like taking dental impressions. By the 4th year, students start working with real patients. Proficiency in Italian is required for clinical practice, and Sapienza offers free Italian classes to help international students. Internships are a mandatory part of the program and provide valuable hands-on experience.</p>
                </section>

                <section className="scholarships">
                    <h2>Tuition Fees and Scholarships</h2>
                    <p>Tuition fees at Sapienza range from €300 to €1500 per year, depending on the student's financial situation (ISEE). Scholarships are available through organizations like <strong>Lazio Disco</strong>, which offers financial support for tuition, housing, and other expenses.</p>
                    <a href="http://www.laziodisco.it/">Lazio Disco Scholarships</a>
                </section>

                <section className="living-expenses">
                    <h2>Living in Rome: Accommodation and Expenses</h2>
                    <p>Rome is an affordable city for students compared to other European capitals. Estimated monthly expenses include:</p>
                    <ul>
                        <li><strong>Accommodation:</strong> €450-600 (shared apartment)</li>
                        <li><strong>Food:</strong> €200-300</li>
                        <li><strong>Transport:</strong> €35 (monthly pass)</li>
                        <li><strong>Entertainment and Miscellaneous:</strong> €150-300</li>
                    </ul>
                    <p>Your expense largely depends on your way of spending. The mentioned amount is just an approximate.</p>
                </section>

                <footer className="footer">
                    <h2>Conclusion</h2>
                    <p>The University of Rome La Sapienza offers a world-class education in Dentistry and Dental Prosthetics, combining academic excellence with practical training in one of the most historic and vibrant cities in the world. With its affordable tuition, prestigious reputation, and strong clinical focus, Sapienza is an ideal choice for students pursuing a career in dentistry.</p>
                </footer>
            </div>
        </>
    );
};

export default UniversityPage5;